module.exports = __webpack_public_path__ + "media/src/images/default-avatar-d4c73905494dc8c8b03dcf369675c2f8.svg";